export default {
  searching: 'Ricerca in corso',
}
